<template>

    <div>

        <div style="position: relative;height:70px;margin-bottom:15px">
                <div class="qlargecircularimage qheadercolour" style="position:absolute;left:5px;top:5px"><img style="height:45px;width:45px" class="qbordericon" src="/assets/icons/bet-whi.png"/></div>
                   <div  style="padding-top:5px; padding-left:0px;padding-right: 4px">

                        <h1 class="qmajorheader qalignmiddle " v-html="langConv('Bet Account Summary')"></h1>
                        <h2 class="qsubheader qalignmiddle qsmallfontplus1" v-html="langConv('Account details broken down by Key Statistics')"></h2>
            
                   </div>
        </div>


            <searchcriteria  @criteria="createSummaryData" :startdate="startdate" :user="user" :searchtype="searchtype" >
                <template v-slot:summary>
                
                </template>
            </searchcriteria>

              <div v-if="summarydata.length">
                
                <div class="qbordercolour " style="height: 20px; "></div>

                <div class="grid-x qsmallfontplus1" v-for="(value, key) in summarydata[0]" :key="key" style="border-bottom: 1px solid lightgrey">
                    
                  <div class="cell small-4 text-right qhighlight" style="padding-right:10px">{{ key }}</div>  
       
                  <div class="cell small-8 " style="padding-left:10px;font-weight: 400;">{{ value }} </div> 
            </div>
</div>   

      
    </div>

</template>

<script>
import searchcriteria from "../components/components/searchcriteria.vue"

 export default {
        name:'betsummary',
         metaInfo() {

           
            if (!this.enableMeta) return {};   
             const baseUrl = process.env.VUE_APP_WEBSITE || ''
            const path = (this.$route && this.$route.fullPath) ? this.$route.fullPath : '/' 
            return {
            title: this.langConv('Betting Account Summary | Oddsgalore'),
            meta: [{
        
                vmid: 'description',
                name: 'description',
                content: this.langConv('Get an account summary for each user that registers their bets with Oddsgalore')
            },
            {
                vmid: 'og:title',
                property: 'og:title',
                content: this.langConv('Individual Betting Account Summary | Oddsgalore')
            },    
            ],
            link: [{
                vmid: 'canonical',
                rel: 'canonical',
                href: baseUrl + path
            }]
        }
        },
        data: function () {
            return {
                summarydata: []
            }
        },
        components: {
            searchcriteria
        },
        props: {

           startdate: {
                type: String,
                default: "-30"
           },
           user: {
                type: String,
                default: 'PeteG196'
           },
            searchtype: {
              default:'summary',
              type:String
          },

        },

        methods: {
            async createSummaryData (fromdate,todate,selectedusers) {


             
 
                let startdate = new Date(fromdate).toISOString().slice(0, 10); // these two basically stringfy the date so that can be sent to web api
                let enddate = new Date(todate).toISOString().slice(0, 10);
                let selusers = this.user;

                console.log(selusers)

             
                let params = '[{ "Name": "@startdate", "Value": "' + startdate + '"},{ "Name": "@enddate", "Value": "' + enddate + '"},{ "Name": "@username", "Value": "' + selusers + '"}]';
                let url = process.env.VUE_APP_WEBAPI  + "FeatureTables.svc/RetrieveGenericGet";
                let spname = "BettingSummaryStats_NS";

                this.newgenericresultset(url, params,spname).then(response =>
                        {
                        
                          this.summarydata = response
                      
                        });

                },
               
            }

        }

  
 

 </script>